export default function ChampionImage({ champion, champImg }) {
  return (
    <>
      {champion.is_3_star && <div className="champion-card__stars">★★★</div>}
      {champImg && (
        <img
          src={champImg}
          alt={champion.name}
          className="champion-card__image"
        />
      )}
    </>
  )
}
